import type { FC } from 'react';

import type { ClassStyleProps } from '../../../../types/ClassStyleProps';

export const AppleIcon: FC<ClassStyleProps> = ({ className, style }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 64 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <defs>
        <clipPath id="clip0_22_49">
          <rect width="64" height="64" fill="white" />
        </clipPath>
      </defs>
      <g clipPath="url(#clip0_22_49)">
        <path
          d="M41.4655 10.2073C42.6752 8.81311 43.5975 7.19367 44.1796 5.442C44.7617 3.69032 44.992 1.84093 44.8573 0C41.1435 0.299778 37.6962 2.04644 35.2579 4.86368C34.0903 6.21391 33.2055 7.7847 32.6559 9.48303C32.1063 11.1814 31.903 12.9727 32.0581 14.751C33.8697 14.7661 35.6604 14.3642 37.2917 13.5762C38.923 12.7883 40.3511 11.6356 41.4655 10.2073ZM49.529 34.0137C49.5504 31.5619 50.1963 29.1559 51.4055 27.0229C52.6148 24.8898 54.3477 23.1001 56.4405 21.8225C55.1197 19.9194 53.3737 18.3502 51.3408 17.2394C49.308 16.1286 47.0443 15.5067 44.7293 15.423C39.7376 14.911 35.1299 18.3348 32.4741 18.3348C29.8183 18.3348 26.0745 15.487 21.9148 15.551C19.1954 15.6405 16.5456 16.4334 14.224 17.8522C11.9023 19.271 9.98795 21.2673 8.6677 23.6464C3.03607 33.4378 7.22779 47.9968 12.8594 55.9003C15.4192 59.772 18.619 64.1557 22.8428 63.9957C27.0665 63.8358 28.4424 61.3719 33.3381 61.3719C38.2337 61.3719 39.7376 63.9957 43.8973 63.8998C48.0571 63.8038 51.0009 59.932 53.6887 56.0603C55.5927 53.2494 57.08 50.1777 58.1044 46.9409C55.5685 45.8594 53.4049 44.0588 51.8809 41.7614C50.357 39.4641 49.5393 36.7706 49.529 34.0137Z"
          fill="black"
        />
      </g>
    </svg>
  );
};
